'use client';

import { isServer } from '@fe-common-utils/libs/utils';
import DynamicLoadDatePicker from '@fe-news/components/DatePicker/lazy';
import DynamicLoadCalendar from '@fe-news/components/atoms/Calendar/lazy';
import DateProvider from '@fe-news/context/date-provider';
import { styled } from '@linaria/react';
import type { FC } from 'react';
import { useCallback } from 'react';
import { NewsCategory } from '@fe-news/constants/categories';

const Container = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

type NewsSearchFilterProps = {
  dates?: MaybeUndefined<number[]>;
  onDateChange?: (dates: number[]) => void;
  category?: NewsCategory;
};

const NewsSearchFilter: FC<NewsSearchFilterProps> = ({ category, dates, onDateChange }) => {
  const [startAt = '', endAt = ''] = dates || [];

  const onDateChangeHandler = useCallback(
    (dates: number[]) => {
      if (isServer) return;

      const [startAt = 0, endAt = 0] = dates;

      const url = new URL(window.location.href);
      const { origin, pathname, searchParams } = url;
      const keyword = searchParams?.get('q') || '';

      window.location.href =
        category === NewsCategory.CELEBRITY_AREA || category === NewsCategory.COLUMNISTS
          ? `${origin}${pathname}?start=${startAt || ''}&end=${endAt || ''}`
          : `${origin}${pathname}?q=${keyword}&start=${startAt || ''}&end=${endAt || ''}`;
    },
    [category]
  );

  return (
    <Container>
      <DateProvider>
        <DynamicLoadCalendar timestamp={endAt} />
        <DynamicLoadDatePicker startAt={startAt} endAt={endAt} onDateChange={onDateChangeHandler} />
      </DateProvider>
    </Container>
  );
};

export default NewsSearchFilter;
